import React from "react";
import "./photocontrols.css";

const PhotoControls = ({ photoMode, setPhotoMode }) => {
  return (
    <div className="photo-controls">

      <button
        className={`photo-control-option ${
          photoMode === "photo" ? "active" : ""
        }`}
        onClick={() => setPhotoMode("photo")}
      >
        Photo
      </button>

      <button
        className={`photo-control-option ${
          photoMode === "no-photo" ? "active" : ""
        }`}
        onClick={() => setPhotoMode("no-photo")}
      >
        No Photo
      </button>

    </div>
  );
};

export default PhotoControls;